// src/components/DanhSachSim.jsx
import React, { useEffect, useState } from "react"
import { Table, Tag, Space, Typography, message, Input } from "antd"
import { ShareAltOutlined, ShoppingCartOutlined } from "@ant-design/icons"
import SimNumberPicker from "./components/SimNumberPicker"
import Button from "src/components/MyButton/Button"
import STORAGE, { getStorage, getStorageCookie } from "src/lib/storage"
import { useNavigate } from "react-router-dom"
import ROUTER from "src/router"
import FilterPhoneNumber from "./components/FilterPhoneNumber"
import PublicService from "src/services/PublicService"
import SimDetailPage from "./SimDetailPage"
import AffiliateService from "src/services/AffiliateService"
import ModalAuth from "src/components/Layouts/component/ModalAuth"
import TableCustom from "src/components/Table/CustomTable"

const { Text } = Typography

const _data = [
  {
    key: "1",
    phone: "0877364411",
    type: ["SIM cam kết", "Đuôi số lặp"],
    commitment:
      "Cam kết tiêu dùng tài khoản tối thiểu 49.000đ/tháng trong 12 tháng.",
    price: "0đ",
    oldPrice: "210.000đ",
  },

  // Thêm nhiều dòng dữ liệu...
]
const BuySim = () => {
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(false)
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
  })
  const [productRecord, setProductRecord] = useState(null)
  const [modalLoginOpen, setModalLoginOpen] = useState(false)

  const navigate = useNavigate()
  const role = localStorage.getItem(STORAGE.ROLES)
  const isLogin = getStorageCookie(STORAGE.TOKEN)

  useEffect(() => {
    fetchListSim()
  }, [pagination.current, pagination.pageSize])

  const fetchListSim = async keyword => {
    const response = await PublicService.getListSimSell({
      page: pagination.current,
      per_page: pagination.pageSize,
      // filter: {
      //   status: 1,
      // },
      type: 2,
      // keyword: keyword,
    })

    const success = response?.success
    if (success) {
      const packages = success.data || []
      const total = success.total || 0
      const current = success.current_page || 1
      const perPage = success.per_page || 50

      setData(packages)
      setPagination({
        ...pagination,
        total,
      })
    } else {
      console.error("Failed to fetch packages:", response?.error)
    }
  }
  const handleSharePackage = async record => {
    try {
      const response = await AffiliateService.createLinkAffiliate({
        name: record.phone_number,
        target_url: `${window.location.origin}/detail-sim/${record.ID}`,
      })
      const link = response
      if (link) {
        await navigator.clipboard.writeText(link) // Tự động copy vào clipboard
        message.success("Sao chép link chia sẻ thành công !")
      } else {
        message.warning("Lỗi tạo link !")
      }
    } catch (error) {
      console.error("Error creating affiliate link:", error)
      message.error("Không thể tạo link chia sẻ")
    }
  }
  const handleBuyNow = record => {
    console.log(role, "role")
    console.log(isLogin, "isLogin")
    console.log(record, "record")
    if (!isLogin) {
      message.error("Vui lòng đăng nhập")
      // return navigate(ROUTER.DANG_NHAP, { state: { from: "order", record } })
      setModalLoginOpen(true)
      setProductRecord(record)
      return
    }
    // return navigate(ROUTER.SALES_BUY_PACKAGE, { state: { record } })
    return navigate(`/detail-sim/${record.ID}`)
  }

  const columns = [
    {
      title: "SỐ ĐIỆN THOẠI",
      align: "center",
      dataIndex: "phone_number",
      key: "phone_number",
      render: text => <Text strong>{text}</Text>,
    },
    {
      title: "NHÀ MẠNG",
      align: "center",
      dataIndex: "carrier",
      key: "carrier",
      render: text => {
        const colors = {
          Viettel: "green",
          Vinaphone: "blue",
          Mobifone: "red",
        }
        return (
          <Text strong style={{ color: colors[text?.name] || "black" }}>
            {text?.name}
          </Text>
        )
      },
    },
    {
      title: "LOẠI SIM",
      dataIndex: "type_sim",
      align: "center",
      key: "type_sim",
      render: tag => {
        let label = ""
        let color = ""

        switch (tag) {
          case "esim":
          case "1":
            label = "eSIM"
            color = "blue"
            break
          case "usim":
          case "2":
            label = "SIM vật lý"
            color = "green"
            break
          default:
            label = ""
            color = "default"
        }

        return <Tag color={color}>{label}</Tag>
      },
    },
    {
      title: "GÓI CƯỚC",
      dataIndex: "package",
      key: "package",
      render: text => <div style={{ maxWidth: 300 }}>{text?.name}</div>,
      // align:center,
      align: "center",
    },
    // {
    //   title: "PHÍ CHỌN SỐ",
    //   key: "unit_price",
    //   render: (_, record) => {
    //     const originalPrice = Number(record?.unit_price || 0)
    //     return (
    //       <div>
    //         <Text strong>0</Text>
    //         <br />
    //         <Text delete type="secondary">
    //           {originalPrice.toLocaleString()}
    //         </Text>
    //         <br />
    //         <Tag color="#f50">-100%</Tag>
    //       </div>
    //     )
    //   },
    // },

    {
      title: "",
      key: "action",
      align: "center",

      render: record => (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Button
            btnType="primary1"
            icon={<ShoppingCartOutlined />}
            danger
            onClick={() => {
              handleBuyNow(record)
            }}
          >
            Mua ngay
          </Button>
        </div>
      ),
    },
    {
      title: "", // nút chia sẻ
      key: "share",
      width: 50,
      render: record => (
        <Button
          type="text"
          icon={<ShareAltOutlined style={{ color: "#1890ff" }} />}
          onClick={() => handleSharePackage(record)}
          title="Chia sẻ gói"
        />
      ),
    },
  ]

  const handleTableChange = newPagination => {
    setPagination({
      ...pagination,
      current: newPagination.current,
      pageSize: newPagination.pageSize,
    })
  }
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        marginTop: 30,
        marginBottom: 16,
        flexDirection: "column",
        flexWrap: "wrap",
        gap: 8,
      }}
    >
      <h3
        style={{
          fontSize: "24px",
          fontWeight: "bold",
          color: "#005F90",
          margin: 0,
        }}
      >
        DANH SÁCH SIM <Text type="secondary">({pagination.total} số)</Text>
      </h3>
      <FilterPhoneNumber />
      {/* <SimDetailPage /> */}
      <Table
        columns={columns}
        dataSource={data}
        showPagination
        pagination={{
          current: pagination.current,
          pageSize: pagination.pageSize,
          total: pagination.total,
          showSizeChanger: true,
          pageSizeOptions: ["10", "20", "50", "100"],
        }}
        onChange={handleTableChange}
        footerLeft={<div className="d-flex mt-20" />}
        widthScroll={1200}
        textEmpty="Không có dữ liệu!"
        scroll={{ x: "max-content" }}
        loading={loading}
      />
      {modalLoginOpen && (
        <ModalAuth
          visible={modalLoginOpen}
          onClose={() => setModalLoginOpen(false)}
          record={productRecord}
        />
      )}
    </div>
  )
}

export default BuySim
